import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../footer/footer';


const FooterLayout = () => {
    return (
        <>
            <Outlet />
            <Footer />
        </>
    )
}

export default FooterLayout;